import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getDashboard = () : Promise<IDashboard> => {
  return axiosDefaultApi.get(`/api/Dashboard/Count`);
};

type QueryFnType = typeof getDashboard;

type UseGetDashboardOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetDashboard = ({ config }: UseGetDashboardOptions = {}) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getDashboard`],
    queryFn: () => getDashboard(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των στατιστικών.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};

interface IDashboard {
  atms: number,
  dCompanies: number,
  departments: number,
  establishments: number,
  units: number,
  phoneLines: number,
  dataLines: number,
  places: number
}